import React from "react";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

function BillingCycleSelection({ plans, choosePlan }) {
    let yearlyPrice = plans && formatter.format(plans.yearly.price);
    let monthlyPrice = plans && formatter.format(plans.monthly.price);

    return (
        <div>
            <div
                id="plan-selection"
                className="input-toggle-container margin-t-m"
            >
                <div className="input-toggle">
                    <input
                        id="team-yearly"
                        className="plan-yearly input-toggle-input"
                        type="radio"
                        name="plan"
                        value="team-yearly"
                        onChange={e => choosePlan(e.target.value)}
                        defaultChecked
                    />
                    <label className="input-toggle-label" htmlFor="team-yearly">
                        Pay yearly
                    </label>
                </div>
                <div className="input-toggle">
                    <input
                        id={"team-monthly"}
                        className="plan-monthly input-toggle-input"
                        type="radio"
                        name="plan"
                        value={"team-monthly"}
                        onChange={e => choosePlan(e.target.value)}
                    />
                    <label
                        className="input-toggle-label"
                        htmlFor={"team-monthly"}
                    >
                        {" "}
                        Pay monthly
                    </label>
                </div>
            </div>
            <div className="display-flex font-xsmall">
                <span className="dollar-value">
                    {yearlyPrice} per year per member
                </span>
                <span className="dollar-value">
                    {monthlyPrice} per month per member
                </span>
            </div>
        </div>
    );
}

export default BillingCycleSelection;
